<app-aggregated-amount-item
  name="ニュースレター"
  icon="./assets/universal_music.png"
  amount="{{ (newsletterSubscriberCountModel$ | async)?.units }}"
  hasAmount="{{ (newsletterSubscriberCountModel$ | async)?.hasUnits }}"
  unit="購読者数"
  [rate]="(newsletterSubscriberCountModel$ | async)?.rate"
  link=""
  help="選択期間内に取得できた最新のニュースレター購読者数を表示しています。"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
  [isDecimal]="true"
></app-aggregated-amount-item>
